import { useEffect, useMemo, useState } from 'react';
import { TransactionFlow } from '../../enums';
import { useGetReceipt } from '../useGetReceipt';
export function useReceipt(props) {
    const { receipt, loading, error, getReceipt } = useGetReceipt();
    const [showDeleteSchedule, setShowDeleteSchedule] = useState(false);
    const showShareReceiptButton = useMemo(() => {
        return (props.transactionFlow !== TransactionFlow.SCHEDULED ||
            (props.transactionFlow === TransactionFlow.SCHEDULED && !props.instructionFlow));
    }, [props.transactionFlow]);
    const showDeleteScheduleButton = useMemo(() => {
        return props.transactionFlow === TransactionFlow.SCHEDULED;
    }, [props.transactionFlow]);
    useEffect(() => {
        getReceipt((props.endToEndId ?? props.transactionId), props.transactionType, props.transactionFlow, props.coreBankId, props.instructionFlow);
    }, [
        props.transactionId,
        props.transactionType,
        props.transactionFlow,
        props.coreBankId,
        props.instructionFlow,
        props.endToEndId,
    ]);
    return {
        receipt,
        loading,
        error,
        showShareReceiptButton,
        showDeleteScheduleButton,
        showDeleteSchedule,
        setShowDeleteSchedule,
    };
}
